import { jbColors } from 'theme/jbColors';

const MuiDataGrid = {
  styleOverrides: {
    root: {
      outline: 'none !important',
      '& .MuiDataGrid-columnHeader': {
        borderBottom: `1px solid ${jbColors.black[60]}`,
      },
      '& .MuiDataGrid-cell': {
        borderBottom: `1px solid ${jbColors.app.lightGrey}}`,
        outline: 'none !important',
      },
      '& .MuiDataGrid-row': {
        borderBottom: `1px solid ${jbColors.app.lightGrey}}`,
      },
      '& .MuiDataGrid-sortIcon': {
        opacity: 'inherit !important',
      },
      '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
        outline: 'none !important',
      },
      fontSize: '12px',
    },
  },
};

export default MuiDataGrid;
